import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaServicestack, FaHouseUser, FaHome, FaUser, FaHeartbeat, FaHouseDamage, FaMoneyCheck, FaPeopleCarry, FaLifeRing, FaRoute, FaAddressCard, FaShoppingBasket, FaShare, FaList, FaArchive, FaUsers, FaFilePdf, FaBrain, FaFileContract, FaDisease, FaHeartBroken, FaArrowAltCircleRight, FaFileUpload } from 'react-icons/fa';
import { useAuth } from '../../../Auth/AuthContext';
import { savePermisosPaginas, getPermisosPaginas } from '../../Utils/indexedDBUtils';

const MenuCaracterizacion = ({ idCabezaFamilia }) => {
    const { rol, fetchPermisosPaginas } = useAuth();
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    async function consultarPermisosPaginas() {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos);
            }
        }
    }
    useEffect(() => {
        consultarPermisosPaginas()
    }, [fetchPermisosPaginas]);
    const section1Links = [
        { 
            to: `/caracterizacion/grupofamiliar/${idCabezaFamilia}`, 
            tooltip: "Grupo familiar", 
            icon: <FaUsers size={20} />, 
            label: "Familia", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Grupo Familiar")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) 
        },
        { 
            to: `/caracterizacion/ubicacion/${idCabezaFamilia}`, 
            tooltip: "Ubicacion", 
            icon: <FaServicestack size={20} />, 
            label: "Ubicacion", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Ubicacion")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/caracterizacion/hechosvictimizantes/${idCabezaFamilia}`, 
            tooltip: "Hechos victimizantes", 
            icon: <FaHeartbeat size={20} />, 
            label: "Hechos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Hechos Victimizantes")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) 
        },
        { 
            to: `/ahe/crearatencionahe/${idCabezaFamilia}`, 
            tooltip: "Registrar entrega AHE", 
            icon: <FaShoppingBasket size={20} />, 
            label: "AHE", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AHE")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/caracterizacion/perdidas/${idCabezaFamilia}`, 
            tooltip: "Perdidas", 
            icon: <FaHouseDamage size={20} />, 
            label: "Perdidas", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Perdidas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
            className: "btn btn-app bg-primary"
        },
        { 
            to: `/caracterizacion/deudas/${idCabezaFamilia}`, 
            tooltip: "Deudas", 
            icon: <FaMoneyCheck size={20} />, 
            label: "Deudas", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Deudas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)), 
            className: "btn btn-app bg-primary"
        },
        { 
            to: `/caracterizacion/unidadfamiliar/${idCabezaFamilia}`, 
            tooltip: "Unidad familiar", 
            icon: <FaPeopleCarry size={20} />, 
            label: "U. Familiar", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Unidad Familiar")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)), 
            className: "btn btn-app bg-primary"
        },
        { 
            to: `/caracterizacion/vidalibertad/${idCabezaFamilia}`, 
            tooltip: "Vida y libertad", 
            icon: <FaLifeRing size={20} />, 
            label: "Vida", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Vida y libertad")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
            className: "btn btn-app bg-primary"
        },
        { 
            to: `/retornos/retorno/${idCabezaFamilia}`, 
            tooltip: "Retornos", 
            icon: <FaRoute size={20} />, 
            label: "Retornos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Retornos")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/retornos/seguimientoretorno/${idCabezaFamilia}`, 
            tooltip: "Seguimiento a retornos", 
            icon: <FaAddressCard size={20} />, 
            label: "Seguimiento", 
            className: "btn btn-app bg-primary",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Retornos seguimiento")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/albergues/albergue/${idCabezaFamilia}`, 
            tooltip: "Albergue", 
            icon: <FaHouseUser size={20} />, 
            label: "Albergue", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Albergue")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/pae/creardesembolso/${idCabezaFamilia}`, 
            tooltip: "Registrar desembolsos", 
            icon: <FaArchive size={20} />, 
            label: "Desembolsos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Autonomia")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/caracterizacion/psicosocial/${idCabezaFamilia}/0`, 
            tooltip: "Atención psicosocial", 
            icon: <FaBrain size={20} />, 
            label: "Psicosocial", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Psicosocial")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/caracterizacion/juridico/${idCabezaFamilia}/0`, 
            tooltip: "Juridico", 
            icon: <FaFileContract size={20} />, 
            label: "Juridico", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Juridico")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/ddhh/vulneraciones/${idCabezaFamilia}`, 
            tooltip: "Vulneraciones", 
            icon: <FaHeartBroken size={20} />, 
            label: "Vulneraciones", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Vulneraciones")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/ddhh/alojamiento/${idCabezaFamilia}`, 
            tooltip: "Alojamiento", 
            icon: <FaHome size={20} />, 
            label: "Alojamiento", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AlojamientoDdhh")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        }
    ];

    const section2Links = [
        { 
            to: `/orientacion/crearatencion/${idCabezaFamilia}`, 
            tooltip: "Registrar atencion", 
            icon: <FaUser size={20} />, 
            label: "Atencion", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/orientacion/crearderivacion/${idCabezaFamilia}`, 
            tooltip: "Registrar derivaciones", 
            icon: <FaUser size={20} />, 
            label: "Derivaciones" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/remisiones/remision/${idCabezaFamilia}`, 
            tooltip: "Remisiones", 
            icon: <FaShare size={20} />, 
            label: "Remision", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/remisiones/remisionregistraduria/${idCabezaFamilia}`, 
            tooltip: "Remisiones registraduria", 
            icon: <FaShare size={20} />, 
            label: "Registraduria", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/consulta/consultaatenciones/${idCabezaFamilia}`, 
            tooltip: "Consulta de registros", 
            icon: <FaList size={20} />, 
            label: "Registros", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/archivo/carpeta/${idCabezaFamilia}`, 
            tooltip: "Ver carpeta de archivos", 
            icon: <FaArchive size={20} />, 
            label: "Carpeta", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        { 
            to: `/dx/recepciondx`, 
            tooltip: "Recepcion diagnostico base", 
            icon: <FaHeartbeat size={20} />, 
            label: "Dx", 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionVictimas")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
        {
            to: `/bodega/descargaractas`,
            tooltip: "Descargar actas",
            icon: <FaFilePdf size={20} />,
            label: "Descargar",
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AHE")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/ddhh/atencionddhh/${idCabezaFamilia}`, 
            tooltip: "Atención DDHH", 
            icon: <FaHeartbeat size={20} />, 
            label: "Atención DDHH" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionDDHH")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },  
        { 
            to: `/ddhh/derivacionddhh/${idCabezaFamilia}`, 
            tooltip: "Registrar derivaciones", 
            icon: <FaArrowAltCircleRight size={20} />, 
            label: "Derivaciones DDHH" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionDDHH")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/ddhh/remisionddhh/${idCabezaFamilia}`, 
            tooltip: "Remisiones", 
            icon: <FaShare size={20} />, 
            label: "Remision DDHH" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionDDHH")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/ddhh/registroatenciones/${idCabezaFamilia}`, 
            tooltip: "Registros atenciones DDHH", 
            icon: <FaList size={20} />, 
            label: "Registros DDHH" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AtencionDDHH")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/caracterizacion/cargarcedulas/${idCabezaFamilia}`, 
            tooltip: "Cargar cédulas", 
            icon: <FaFileUpload size={20} />, 
            label: "Cargar cédulas" , 
            className: "btn btn-app bg-info",
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Cargar Cedula")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        
    ];

    const renderLinks = (links) => {
        return links.map((link, index) => (
            !link.hidden && (
                <NavLink
                    key={index}
                    to={link.to}
                    className={link.className}
                    data-tooltip-id="tooltiparriba"
                    data-tooltip-content={link.tooltip}
                >
                    {link.icon}
                    <p>{link.label}</p>
                </NavLink>
            )
        ));
    };

    return (
        <div className="card">
            <div>
                <div className="row">
                    <div className="col-md-12 no-padding">
                        {renderLinks(section1Links)}
                    </div>
                </div>
            </div>
            <div>
                <div className="row">
                    <div className="col-md-12 no-padding">
                        {renderLinks(section2Links)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuCaracterizacion;